import { Button, Card, Container } from '@components'
import Fields from '@components/fields'
import { StyleColumn } from '@components/styles'
import { requestPermission } from '@utils/pushNotification'
import { AuthSchema } from '@validations'
import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { styleCard, StyleFormTitle, StyleFormWrapper, StyleRow } from './style'
import { Admin } from '@apis'
import { Helper } from '@utils/index'

const AdminLogin = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [fcmToken, setFcmToken] = useState<any>('')
  const initialValues = {
    username: '',
    password: '',
  }
  const fetchFCMToken = async () => {
    try {
      const fcmToken = await requestPermission()
      setFcmToken(fcmToken)
    } catch (error) {
      console.error('Error fetching FCM token:', error)
    }
  }

  useEffect(() => {
    fetchFCMToken()
  }, [])

  const submitHandler = async (values: any) => {
    setLoading(true)
    const payload: any = {
      username: values.username,
      password: values.password,
    }
    if (!!fcmToken) {
      payload.deviceToken = fcmToken
    }

    await Admin.login(payload)
      .then((resp) => {
        Helper.saveUser(resp)
        navigate('/admin/dashboard')
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Container>
      <StyleRow>
        <StyleFormWrapper>
          <Card customStyle={styleCard} radius={12} outline>
            <StyleFormTitle>
              Shareabook <span>Admin Login </span>
            </StyleFormTitle>
            <Formik
              validationSchema={AuthSchema.adminLoginValidationSchema}
              initialValues={initialValues}
              onSubmit={submitHandler}
            >
              {({ handleSubmit }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <StyleColumn>
                      <Fields.Input
                        name="username"
                        label="Username"
                        placeholder="Enter your Username"
                        styleWrapper=""
                      />
                      <Fields.Password
                        name="password"
                        label="Password"
                        placeholder="Enter your password"
                      />

                      <Button
                        type="submit"
                        title="Login"
                        height={40}
                        loading={loading}
                      />
                    </StyleColumn>
                  </Form>
                )
              }}
            </Formik>
          </Card>
        </StyleFormWrapper>
      </StyleRow>
    </Container>
  )
}

export default AdminLogin
